// import Vue from 'vue'

const recipe = window.__INIT_DATA.recipe || {}

export default {
  recipe: recipe,
  current: recipe.serving_count,
  selectable: false,
  mode: 'display',
  preselected: false
}



// WEBPACK FOOTER //
// ./src/components/ingredients/shared.js